"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogStyles = void 0;
var widgets_1 = require("@tableau/widgets");
var typestyle_1 = require("typestyle");
var DialogStyles;
(function (DialogStyles) {
    DialogStyles.DialogContent = (0, typestyle_1.style)({
        fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
    });
    DialogStyles.BottomButtons = (0, typestyle_1.style)({
        display: 'flex',
        justifyContent: 'flex-end',
    });
    DialogStyles.PrimaryButton = (0, typestyle_1.style)({
        marginLeft: widgets_1.TabStyles.Typography.Sizing.Default,
    });
    DialogStyles.HelpExpando = (0, typestyle_1.style)({
        marginBottom: widgets_1.TabStyles.Spacing.LargeSpace,
        marginTop: '16px',
    });
    DialogStyles.ExpandMessage = (0, typestyle_1.style)({
        marginBottom: widgets_1.TabStyles.Spacing.DefaultSpace,
    });
    DialogStyles.HelpText = (0, typestyle_1.style)({
        margin: '0px',
    });
})(DialogStyles = exports.DialogStyles || (exports.DialogStyles = {}));
//# sourceMappingURL=DialogStyles.js.map